import React from 'react';

import {getStorableRelevantItemRowData} from 'relevant-items/getStorableRelevantItemsRowData';
import RelevantItemsTable from 'relevant-items/shared/RelevantItemsTable';
import {StorableRelevantItemsGraphQL} from 'relevant-items/storables/__generated/StorableRelevantItemsGraphQL';

import {
  StorableRelevantItemsFilteredTableState,
  UpdateStorableRelevantItemsFilteredTableState,
} from './StorableRelevantItemsFilteredTableState';

export interface StorableRelevantItemsSectionTableProps {
  relevantItemsGraphQL: StorableRelevantItemsGraphQL;
  filteredTableState: StorableRelevantItemsFilteredTableState;
  updateFilteredTableState: UpdateStorableRelevantItemsFilteredTableState;
  storableId: string;
  /** @default false */
  isCompact?: boolean;
  /** @default 100 */
  paginationLimit?: number;
}

export default function StorableRelevantItemsSectionTable({
  relevantItemsGraphQL,
  filteredTableState,
  updateFilteredTableState,
  storableId,
  isCompact,
  paginationLimit,
}: StorableRelevantItemsSectionTableProps): JSX.Element {
  const rowData = getStorableRelevantItemRowData(
    filteredTableState.filterOption,
    relevantItemsGraphQL,
    storableId
  );

  return (
    <RelevantItemsTable
      rowData={rowData}
      searchQuery={filteredTableState.searchQuery}
      pageOffset={filteredTableState.pageOffset}
      setPageOffset={(pageOffset) => {
        updateFilteredTableState({pageOffset});
      }}
      sortStateId={storableId}
      isCompact={isCompact}
      paginationLimit={paginationLimit}
    />
  );
}
